import {
  SKIP,
  custom,
  deserialize,
  object,
  optional,
  serializable,
} from 'serializr';
import { SalesforceObjectField } from './salesforce-object-fields.model';
import { TestDataType } from '@modules/test-development/models/test-data-type.enum';
import { SalesforceAPIStepDataGeneratorArgument } from './salesforce-api-step-data-generator-argument.model';

export class SalesforceAPIStepDataMap {
  @serializable
  public id: number;

  @serializable
  public stepId: string;
  @serializable
  public parameterName: string;
  @serializable
  public parameterValue: string;
  @serializable
  public parameterType: TestDataType;
  @serializable
  public functionId: number;
  @serializable
  public testDataProfileId: number;
  @serializable
  public phoneNumberId: number;
  @serializable
  public mailboxId: number;
  @serializable
  public isEnabled: boolean;

  @serializable
  public isSelected: boolean;

  @serializable
  public isMultiValueSupported: boolean;

  @serializable
  public salesforceObjectFieldId: number;

  @serializable(
    optional(
      custom(
        () => SKIP,
        (v) => v,
      ),
    ),
  )
  public dataGeneratorArguments: SalesforceAPIStepDataGeneratorArgument[];

  @serializable(object(SalesforceObjectField))
  public salesforceObjectField: SalesforceObjectField;

  @serializable(
    optional(
      custom(
        () => SKIP,
        (v) => v,
      ),
    ),
  )
  public childDataMaps: SalesforceAPIStepDataMap[];

  public data: any[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(SalesforceAPIStepDataMap, input));
  }
}
